module.exports = __webpack_public_path__ + "img/flame.c4b03f5.svg";